import * as a from "react";
import { c as r } from "../createReactComponent-58f9bea8.mjs";
import { b as t, r as e } from "../avatar-e534285e.mjs";
import { a as x, A } from "../avatar-e534285e.mjs";
import "../property-9daa16cd.mjs";
import "../class-map-2994e95e.mjs";
const i = r({ tagName: "ex-avatar", elementClass: t, react: a, events: {}, displayName: "ExAvatar", registerWebComponent: e });
export {
  x as AvatarSize,
  A as AvatarType,
  i as ExAvatar,
  e as register
};
